import moment from "moment"
import React, { useEffect, useState } from "react"
import { Button } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import ScaleLoader from "react-spinners/ScaleLoader"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import DateRangePickerCustom from "../../components/Common/DateRangePicker/DateRangePickerCustom"
import { RootState } from "../../store"
import { loadCountry } from "../../store/customer.store"
import { loadPromoById, loadPromoCodes } from "../../store/promoCode.store"
import Header from "../Layout/Header"
import AddPromoCodeModal from "./AddPromoCodeModal"
import PromoCodeTable from "./PromoCodesTable"
import ViewPromoCodesModal from "./ViewPromoCodesModal"

const PromoCodes = () => {
    const dispatch = useAppDispatch()
    const { userInfo } = useAppSelector((state: RootState) => state.auth)
    const { promoCodes, loading } = useAppSelector((state: RootState) => state.promoCodes)
    const { countryList, parcelCustomers: customers } = useAppSelector((state: RootState) => state.customers)

    const [promoCodesData, setPromoCodesData] = useState({})
    const [show, setShow] = useState(false)
    const [edit, setEdit] = useState(false)
    const [addShow, setAddShow] = useState(false)
    const [CountryList, setCountryList] = useState([] as Record<string, any>)
    const [CustomerList, setCustomerList] = useState([] as Record<string, any>)

    const { t } = useTranslation()
    const handleClose = () => {
        setShow(false)
        dispatch(loadPromoCodes())
    }
    const PromoCodesShow = (data: any) => {
        setPromoCodesData(data)
        setShow(true)
    }

    const handleEditShow = (data: any) => {
        dispatch(loadPromoById({ id: data.id }))
        setEdit(true)
        setAddShow(true)
    }
    const handleAddClose = () => {
        setAddShow(false)
        setEdit(false)
        dispatch(loadPromoCodes())
    }

    const AddPromoCodesShow = (data: any) => {
        setAddShow(true)
        setEdit(false)
    }
    useEffect(() => {
        dispatch(loadPromoCodes())
        dispatch(loadCountry())
    }, [])

    useEffect(() => {
        let countryAll = [{ value: "", label: "All" }]
        let countryData = countryList?.map((country: any) => ({
            value: country.iso2_code,
            label: country?.name
        }))
        setCountryList(countryAll.concat(countryData))
    }, [countryList])

    //Date Picker Logic
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")

    useEffect(() => {
        const dateObj2 = {
            start_date: startDate ? moment(startDate).format("YYYY-MM-DD") : "2020-04-15",
            end_date: endDate
                ? moment(endDate).format("YYYY-MM-DD")
                : moment().add(1, "days").format("YYYY-MM-DD")
        }
        //TODO: Call dispatch(load***()) for all
    }, [endDate])
    return (
        <>
            {loading || !userInfo?.accessToken ? (
                <div className="loader row justify-content-center">
                    <ScaleLoader color="#15397F" width={4} height={40} />
                </div>
            ) : (
                <div className="suites-container">
                    <Header
                        title={t("Promo_Codes")}
                        records={promoCodes?.length}
                        data={promoCodes}
                        name="PromoCodes"
                        buttonId=".promoCodeExportButton">
                        <div className="mx-2">
                            <DateRangePickerCustom
                                setStartDate={setStartDate}
                                setEndDate={setEndDate}
                                startDate={startDate}
                                endDate={endDate}
                            />
                        </div>
                    </Header>
                    <div className="row justify-content-end px-4 mt-3">
                        <Button className="col-2" onClick={AddPromoCodesShow}>
                            {t("Add Promo Code")}
                        </Button>
                    </div>
                    <div className="row d-flex px-2">
                        <PromoCodeTable
                            promoCodes={promoCodes}
                            PromoCodesShow={PromoCodesShow}
                            handleEditShow={handleEditShow}
                            handleClose={handleClose}
                            startDate={startDate}
                            endDate={endDate}
                        />
                    </div>
                    <ViewPromoCodesModal show={show} handleClose={handleClose} data={promoCodesData} />
                    <AddPromoCodeModal
                        show={addShow}
                        handleClose={handleAddClose}
                        edit={edit}
                        CountryList={CountryList}
                        customers={customers}
                    />
                </div>
            )}
        </>
    )
}

export default PromoCodes
